import cmp from './AdditionalDocuments'

export default cmp
